import { useEffect, useState } from 'react';
import CollapseToggle from './CollapseToggle';
import {
  FaTimes, FaUtensils, FaCoffee, FaShoppingCart, FaHospital,
  FaCapsules, FaSchool, FaGasPump, FaParking,
  FaMoneyBillWave, FaHotel
} from 'react-icons/fa';

const CATEGORY_ICONS = {
  restaurant:  { icon: FaUtensils,      color: '#FF6B6B', label: 'Restaurant' },
  cafe:        { icon: FaCoffee,        color: '#D4A574', label: 'Cafe' },
  supermarket: { icon: FaShoppingCart,  color: '#4ECDC4', label: 'Supermarket' },
  hospital:    { icon: FaHospital,      color: '#FF6B8A', label: 'Hospital' },
  pharmacy:    { icon: FaCapsules,      color: '#45B7D1', label: 'Pharmacy' },
  school:      { icon: FaSchool,        color: '#96CEB4', label: 'School' },
  gas_station: { icon: FaGasPump,       color: '#FFEAA7', label: 'Gas Station' },
  parking_lot: { icon: FaParking,       color: '#74B9FF', label: 'Parking' },
  atm:         { icon: FaMoneyBillWave, color: '#55E6C1', label: 'ATM' },
  hotel:       { icon: FaHotel,         color: '#A29BFE', label: 'Hotel' },
};

function FacilityPanel({ facility, onClose }) {
  const [collapsed, setCollapsed] = useState(false);
  useEffect(() => { setCollapsed(false); }, [facility]);
  if (!facility) return null;

  const props = facility.properties || {};
  const coords = facility.geometry?.coordinates;
  const category = props._category || '';
  const config = CATEGORY_ICONS[category];
  const IconComponent = config?.icon;

  return (
    <div className={`facility-panel ${collapsed ? 'panel-collapsed' : ''}`}>
      <div className="facility-panel-header">
        <h3>
          {IconComponent && (
            <span className="facility-header-icon" style={{ color: config.color }}>
              <IconComponent size={18} />
            </span>
          )}
          {props.name || 'Unknown'}
        </h3>
        <span className="panel-head-actions">
          <CollapseToggle collapsed={collapsed} name="facility details" onToggle={() => setCollapsed((c) => !c)} />
          <button className="facility-panel-close" onClick={onClose}>
            <FaTimes size={16} />
          </button>
        </span>
      </div>
      <div className="facility-panel-content">
        <div className="facility-info-row">
          <span className="facility-label">Category</span>
          <span className="facility-value">
            {IconComponent && <IconComponent size={12} color={config.color} style={{ marginRight: 6 }} />}
            {config?.label || category.replace(/_/g, ' ')}
          </span>
        </div>
        {props.full_address && (
          <div className="facility-info-row">
            <span className="facility-label">Address</span>
            <span className="facility-value">{props.full_address}</span>
          </div>
        )}
        {props.address && !props.full_address && (
          <div className="facility-info-row">
            <span className="facility-label">Address</span>
            <span className="facility-value">{props.address}</span>
          </div>
        )}
        {props.place_formatted && (
          <div className="facility-info-row">
            <span className="facility-label">Area</span>
            <span className="facility-value">{props.place_formatted}</span>
          </div>
        )}
        {coords && (
          <div className="facility-info-row">
            <span className="facility-label">Coordinates</span>
            <span className="facility-value">{coords[1].toFixed(5)}, {coords[0].toFixed(5)}</span>
          </div>
        )}
        {props.poi_category && (
          <div className="facility-info-row">
            <span className="facility-label">Tags</span>
            <span className="facility-value facility-tags">
              {(Array.isArray(props.poi_category) ? props.poi_category : [props.poi_category]).map(tag => (
                <span key={tag} className="facility-tag">{tag}</span>
              ))}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default FacilityPanel;
